export default __webpack_public_path__ + "static/media/H0006.28f705cd.png";